import { guestimateDateFnsLocaleFromLanguage } from '@lessonup/utils';
import { format } from 'date-fns/format';
import { LanguageKey } from '../domain';

/** data-fns does not support strings, but we have those in our database.
 * Cast strings to date without validating
 */
export function stringToDateUnsafe(date: Date | string): Date {
  return typeof date === 'string' ? new Date(date) : date;
}

export function getFormattedDateForLanguage(
  date: Date,
  language: LanguageKey,
  options: { format: string } = { format: 'P' }
): string {
  const locale = guestimateDateFnsLocaleFromLanguage(language);
  return format(new Date(date), options.format, { locale });
}
